import React, { useState, createContext, useContext } from 'react';
export type Role = 'admin' | 'manager' | 'officer';
interface RoleContextType {
  role: Role;
  setRole: (role: Role) => void;
}
const RoleContext = createContext<RoleContextType | undefined>(undefined);
export function RoleProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [role, setRole] = useState<Role>('officer');
  return <RoleContext.Provider value={{
    role,
    setRole
  }} data-id="element-289" data-mp="phgrt2p0f5an">
      {children}
    </RoleContext.Provider>;
}
export function useRole() {
  const context = useContext(RoleContext);
  if (context === undefined) {
    throw new Error('useRole must be used within a RoleProvider');
  }
  return context;
}